import cn from "classnames";
import { useSecurityDocumentsExistFlag } from "../../../effects/useSecurityDocumentsExistFlag";
import { isRequestNone, isRequesting } from "../../../utils/request-state.utils";
import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";
import { DealDocumentsPopupTab, DealDocumentsSecurity } from "./DealDocumentsPopup";
import IconSVG from "../../../styles/svg-icons";
import { LocationState, LocationStateBuilder, PopupType } from "../../../types/state/ui/LocationState";
import { useHistory } from "react-router";
import { DealDocumentsPopupGlobalPayload } from "./DealDocumentsPopupGlobal";

interface Props {
    className?: string;
    security: DealDocumentsSecurity;
    requiredFeature?: SubscriptionFeature | null;
    disabled?: boolean;
    checkDocumentsExist?: boolean;
    openTab?: DealDocumentsPopupTab;
    onClick?: () => void;
}

export function ViewDealDocumentsButton({
    className = "",
    security,
    disabled = false,
    checkDocumentsExist = false,
    openTab = DealDocumentsPopupTab.OmAndIndenture,
    requiredFeature = SubscriptionFeature.CanAccessDealDocuments,
    onClick }: Props) {
    const history = useHistory<LocationState<any, DealDocumentsPopupGlobalPayload>>();

    const [requestState, isDocumentsExist] = useSecurityDocumentsExistFlag(security.ticker, !checkDocumentsExist);

    if (checkDocumentsExist && (
        !isDocumentsExist || isRequestNone(requestState) || isRequesting(requestState))) {
        return null;
    }

    const handleClick = () => {
        let locationStateBuilder = new LocationStateBuilder(history.location.state)
            .popup(
                PopupType.DealDocuments,
                { security, requiredFeature, defaultTab: openTab }
            );

        history.replace({ ...history.location, state: locationStateBuilder.result() });
        onClick?.();
    }

    return (
        <button
            className={cn("btn-link", className)}
            type="button"
            disabled={disabled}
            onClick={handleClick}
        >
            <IconSVG name="docs" width={16} height={16} />
            Docs
        </button>
    );
}
